import {createSettingsParams, SettingsParamType} from '@wix/tpa-settings'

import {ButtonAlignment, FormLayout, TextAlignment} from '../../../../../types/createStylesParams'
import {textEnumMetadata} from '../../../../../utils/builderMetadata'

export enum AreasStyle {
  Cards = 'cards',
  Dropdown = 'dropdown',
}

export type LayoutSettingsParams = {
  textAlignment: SettingsParamType.String
  formLayout: SettingsParamType.String
  buttonAlignment: SettingsParamType.String
}

export const layoutSettingsParams = createSettingsParams<LayoutSettingsParams>({
  textAlignment: {
    type: SettingsParamType.String,
    getDefaultValue: () => TextAlignment.Center,
    metadata: textEnumMetadata(
      {defaultValue: TextAlignment.Center},
      'Alignment of the title and description: left, center or right',
    ),
  },
  formLayout: {
    type: SettingsParamType.String,
    getDefaultValue: () => FormLayout.Strip,
    metadata: textEnumMetadata(
      {defaultValue: FormLayout.Strip},
      'Reservation form layout: strip = fields in one row, packed = fields stacked; small screens always use packed',
    ),
  },
  buttonAlignment: {
    type: SettingsParamType.String,
    getDefaultValue: (params) =>
      params.isMobile ? ButtonAlignment.Stretch : ButtonAlignment.Center,
    metadata: textEnumMetadata(
      {defaultValue: ButtonAlignment.Center, mobileDefaultValue: ButtonAlignment.Stretch},
      'Alignment of the continue button: left, center, right or Stretch',
    ),
  },
})

export type AreasLayoutSettingsParams = {
  areasStyle: SettingsParamType.String
  areasCardsAlignment: SettingsParamType.String
  areasTextAlignment: SettingsParamType.String
}

export const areasLayoutSettingsParams = createSettingsParams<AreasLayoutSettingsParams>({
  areasStyle: {
    type: SettingsParamType.String,
    getDefaultValue: () => AreasStyle.Cards,
    metadata: textEnumMetadata(
      {defaultValue: AreasStyle.Cards},
      'How seating areas are shown: cards = selectable cards, dropdown = a dropdown list',
    ),
  },
  areasCardsAlignment: {
    type: SettingsParamType.String,
    getDefaultValue: () => TextAlignment.Left,
    metadata: textEnumMetadata(
      {defaultValue: TextAlignment.Left},
      'Alignment of the seating area cards: left, center or right',
    ),
  },
  areasTextAlignment: {
    type: SettingsParamType.String,
    getDefaultValue: () => TextAlignment.Left,
    metadata: textEnumMetadata(
      {defaultValue: TextAlignment.Left},
      'Alignment of the text inside the seating area cards: left, center or right',
    ),
  },
})
